import { useState, useEffect } from 'react';

const useMutationObserver = (callback, options = { subtree: true, childList: true }) => {
  const [lastUrl, setLastUrl] = useState(window.location.href);
  const [isActive, setIsActive] = useState(true);

  new MutationObserver(() => {
    const url = window.location.href;
    if (url !== lastUrl && isActive) {
      setLastUrl(url);
    }
  }).observe(document, options);

  useEffect(() => {
    if (callback) {
      callback();
    }

    return () => {
      setIsActive(false);
    };
  }, [lastUrl]);
};

export { useMutationObserver };
